import { styled } from '@/stitches.config';

export const TableStyled = styled('table', {
  width: '100%',
  borderCollapse: 'collapse',
});
